import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-close\"><path d=\"M15.954,14,9.831,7.941l6.061-6.116L14-.046,7.945,6.073,1.827.015-.046,1.888l6.124,6.07L.015,14.081l1.873,1.873L7.963,9.826l6.12,6.067Z\" transform=\"translate(0.046 0.046)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol